<script>
	import { onMount } from "svelte";
	import { tweened } from 'svelte/motion';
	import { cubicOut } from 'svelte/easing';

	import LotDims from "./LotDims.svelte";
	import Setbacks from "./Setbacks.svelte";
	import Visualizer from "./Visualizer.svelte";

	import { lotWid, lotLen, lotFace, lotSide, lotRear, buildWid, buildLen, rectArea } from "./stores.js";

	let lotArea, buildArea, boxW, boxH, bldW, bldL;

	let aboutVis = false,
			setVis = true,
			scrSize = "large",
			visDim = 600,
			setStyle = "";

	let drawer;

	const drawerW = tweened(0, {
		duration: 600,
		easing: cubicOut
	});

	const mqls = [
		window.matchMedia("(max-width: 800px)"),
		window.matchMedia("(max-width: 560px)")
	];

	onMount(() => {
		for (let i=0; i<mqls.length; i++) {
			mqHandler(mqls[i]);

			mqls[i].addEventListener('change', mqHandler);
		}
	});

	$: {
		bldW = $lotWid - 2 * $lotSide;
		bldL = $lotLen - ($lotFace + $lotRear);
		lotArea = rectArea($lotWid, $lotLen);
		$buildWid = bldW > 0 ? bldW : 0;
		$buildLen = bldL > 0 ? bldL : 0;
		buildArea = rectArea($buildWid, $buildLen);

		if (scrSize === "small") {
			setStyle = `margin-left: calc(${$drawerW}vw)`;
		} else {
			setStyle = ""
		}
	}

	function mqHandler(mql) {
		if (mqls[0].matches) {
			scrSize = "medium";
		}

		if (mqls[1].matches) {
			scrSize = "small"
		}

		if (!mqls[0].matches && !mqls[1].matches) {
			scrSize = "large"
		}

		visDim = scrSize === "large" ? 600 : 400;
		console.log(scrSize);
	}

	function reset() {
		$lotWid = 100;
		$lotLen = 200;
		$lotFace = 30;
		$lotSide = 10;
		$lotRear = 10;
		$buildLen = bldL;
		$buildWid = bldW;
	}

	function toggleAbout() {
		aboutVis = !aboutVis;
	}

	function toggleSettings() {
		if (setVis) {
			setVis = false;
			drawerW.set(101);
		} else {
			setVis = true;
			drawerW.set(0);
			drawer.scrollTop = 0;
		}

		console.log(drawer);
	}

</script>

<div id="container">
	<section id="settings" style={setStyle} bind:this={drawer}>
		{#if scrSize === "small"}
			<div class="close btn-icon">
				<a href="javascript:void(0)" role="button" on:click={toggleSettings}>
					<img src="img/close.svg" alt="Close">
				</a>
			</div>
		{/if}

		<h1 id="setback-visualizer">Setback Visualizer</h1>
		<div id="info">
			<p>
				<strong>How to use:</strong> input the dimensions of your lot in feet and then input the front, side, and rear setbacks as assigned by your zoning ordinances. The visualizer will update and show the allowable buildable area of your lot.
			</p>
		</div>

		<div id="lot-dims" class="subsection">
			<LotDims />
		</div>
		<div id="setbacks" class="subsection">
			<Setbacks />
		</div>

		<div id="buttons" class="subsection">
			{#if scrSize === "small"}
				<button id="render" on:click={toggleSettings}>
					Visualize
				</button>
			{/if}
			<button class="btn-secondary" on:click={reset}>
				Reset
			</button>
		</div>

		<!-- <div id="about" class="subsection" class:visible={aboutVis}>
			<h3>About</h3>

			<div class="close">
				<a href="javascript:void(0)" role="button" on:click={toggleAbout}>
					<img src="img/close.svg" alt="Close">
				</a>
			</div>

			<p>
				The <a href="http://chuck.aligbe.com/lotviz/">Setback Visualizer</a> version 1.0. &copy; 2022. Made by <a href="http://chuck.aligbe.com/">Chuck Aligbe</a>. The Setback Visualizer is a simple tool to visualize the buildable area for a rectangular lot. Distributed under the MIT License. All rights reserved. Built with <a href="https://svelte.dev/">Svelte</a>
			</p>
		</div> -->

		<footer id="footer">
			<p>
				<a href="https://chuck.aligbe.com/posts/setback-visualizer.html" target="_blank">About the Visualizer</a>
				&nbsp; | &nbsp;
				<a href="https://www.paypal.com/donate?hosted_button_id=SQCSLTW9XHHUJ">Buy me a drink</a>
			</p>
		</footer>

	</section>
	<section id="display">
		{#if scrSize === "small"}
			<div class="menu btn-icon">
				<a href="javascript:void(0)" role="button" on:click={toggleSettings}>
					<img src="img/menu.svg" alt="Settings">
				</a>
			</div>
		{/if}

		<div id="visbox">
			<Visualizer visW={visDim} visH={visDim} />
		</div>

		<div id="area-out">
			<p id="lot-out">
				Lot Area: {lotArea} sf
			</p>
			<p id="build-out">
				Buildable Area: {buildArea} sf
			</p>
			<span class="screen-reader-text">
				Buildable Area Dimensions: {$buildWid}' x {$buildLen}'
			</span>
		</div>
	</section>
</div>

<style>
	#visbox {
		width: clamp(20rem, 50vw, 85vh);
		height: clamp(20rem, 50vw, 85vh);
	}

	@media screen and (max-width: 35rem) {
		#visbox {
      width: 100vw;
      height: 100vw;
    }
	}
</style>
